module.exports = __webpack_public_path__ + "img/instagram.7dd8e409.png";